export default __webpack_public_path__ + "static/media/weightlossregime_4.12a879e8.jpg";